<template>
    <KPL
        class="cls-card-item"
        :class="{'has-zongjia':hasZongjia}"
        :url="card_item.jumpUrl"
        :sku="card_item.skuId"
        :clstag="'jr|keycount|'+clstagName+'|'+card_item.rule||card_item.skuId"
        :eventId="eventId"
        :eventParam="card_item.rule"
        :channel="channel"
    >
        <div class="cls-item-imgWrap">
            <img
                alt="商品"
                class="cls-pic"
                v-lazy="card_item.imageUrl"
            >
            <div class="busCard-free">{{card_item.installment}}期免息</div>
        </div>
        <div class="cls-title">
            <span
                v-if="card_item.isSelfService"
                class="ui-selfRed"
            >自营</span>
            {{card_item.goodsName||''}}
        </div>
        <div
            class="cls-details"
            :class="{'zongjia-wrapper':hasZongjia}"
        >
            <div class="fenqi ellipsis">
                <span class="busCard-dollar">¥</span>
                <span class="busCard-moneyStyle">{{card_item.installmentPrice||'0.00'}}</span>
                <span class="act-everyMonth2">每期</span>
            </div>
            <div
                class="zongjia ellipsis"
                v-if="hasZongjia && card_item.goodsPrice"
            >总价¥{{card_item.goodsPrice}}</div>
        </div>
        <div class="act-main2">
            <span
                v-if="false"
                class="ui-gold"
            >专享</span>
            <!-- <span class="jrm-border-1px jrm-border-homepage-all">{{card_item.installment}}个月免息</span> -->
            <!-- <span class="act-mian busCard-payment jrm-border-1px jrm-border-all-color">白条</span> -->
            <span class="busCard-payment jrm-border-2px jrm-border-all-color">白条</span>
        </div>
    </KPL>
</template>

<script>
import KPL from '@/buscomponents/KPL';

export default {
    name: 'BusCard',
    props: {
        card_item: {
            type: Object,
            default: () => {
                return {};
            }
        },
        eventId: {
            type: String,
            default: ''
        },
        pageId: {
            type: String,
            default: 'zichanyesku'
        },
        hasZongjia: {
            type: Boolean,
            default: false
        },
        clstagName: {
            type: String,
            default: '8530052_index_like'
        },
        channel: {
            type: String,
            default: 'default'
        }
    },
    components: { KPL },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import './../scss/mixin.scss';
.cls-card-item {
    width: 100%;
    height: $rem510;
    background: #ffffff;
    // box-shadow: 0 $rem4 $rem20 0 rgba(187, 187, 187, 0.3);
    padding-top: $rem20;
    .cls-item-imgWrap {
        position: relative;
        .busCard-free {
            padding: 0 $rem14;
            width: auto;
            position: absolute;
            left: $rem24;
            bottom: -$rem20;
            z-index: 1;
            height: $rem40;
            // background: #333333;
            // color: #ffffff;
            background: linear-gradient(270deg, rgba(247, 224, 166, 1) 0%, rgba(239, 195, 136, 1) 100%);
            color: #603b07;
            font-size: $rem24;
            font-family: PingFangSC-Regular;
            // font-weight: 600;
            line-height: $rem40;
        }

        .cls-pic {
            display: block;
            margin: 0 auto;
            height: $rem284;
        }
    }

    .ui-selfRed {
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #ffffff;
        background: #f13a4d;
        padding: 0 $rem4;
        line-height: $rem28;
        height: $rem28;
        margin-right: $rem10;
    }

    .act-everyMonth2 {
        padding-right: $rem4;
        font-family: PingFangSC-Regular;
        font-size: $rem24;
        color: #999999;
        letter-spacing: 0;
    }

    .cls-title {
        overflow: hidden;
        margin: $rem23 $rem24 $rem8;
        height: $rem80;
        color: #333;
        letter-spacing: 0;
        font-size: $rem26;
        font-family: 'PingFangSC-Regular';
        line-height: $rem40;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: normal;
    }
    .act-main2 {
        // height: $rem32;
        padding-left: $rem24;
        text-align: left;
        white-space: nowrap;
        span {
            // font-size: $rem24;
            // color: $jrm-color-C29451;
            // font-family: PingFangSC-Regular;
            text-align: center;
            // padding: $rem4 $rem6;
            // line-height: $rem32;
        }
        .ui-gold {
            font-family: PingFangSC-Regular;
            font-size: $rem24;
            color: #ffffff !important;
            background: #c29451;
            line-height: $rem32;
            padding: $rem4 $rem10;
            // height: $rem28;
        }
        .busCard-payment {
            // border-radius: 1px;
            font-size: $rem20;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            // margin-right: $rem8;
            color: #d29c52;
            padding: 0 $rem8;
            // border: 2px solid #d29c52;
        }
    }

    .cls-details {
        margin-left: $rem24;
        display: flex;
        overflow: hidden;
        align-items: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-bottom: $rem10;
        // :first-child {
        //   color: #c29451;
        //   letter-spacing: 0;
        //   font-size: $rem32;
        //   font-size: large;
        //   font-family: 'Helvetica-Bold';
        //   line-height: $rem45;
        // }
        // :last-child {
        //   margin-left: $rem6;
        //   color: #999;
        //   letter-spacing: 0;
        //   font-size: $rem24;
        //   font-family: 'PingFangSC-Regular';
        //   line-height: $rem33;
        // }
        // .cls-dollar {
        //   color: #c29451;
        //   font-size: $rem24;
        //   // font-family: 'Helvetica-Bold';
        //   line-height: $rem45;
        // }
    }

    .zongjia-wrapper {
        .fenqi {
            height: $rem46;
            max-width: 70%;
        }

        .zongjia {
            height: $rem46;
            line-height: $rem46;
            padding-left: $rem12;
            font-family: PingFangSC-Regular;
            font-size: $rem20;
            color: #999999;
            letter-spacing: 0;
        }
    }
}

.android {
    .cls-card-item {
        .zongjia-wrapper {
            .zongjia {
                // line-height: $rem30;
            }
        }
    }
}

.busCard-dollar {
    color: rgba(241, 58, 77, 1);
    font-size: $rem24;
    font-family: PingFangSC-Semibold;
    /* line-height: $rem45; */
}
.busCard-moneyStyle {
    font-family: UDC104-Bold;
    font-size: $rem30;
    color: rgba(241, 58, 77, 1);
    letter-spacing: 0;
    // font-weight:bold;
    line-height: $rem45;
    margin-right: $rem6;
    margin-left: $rem6;
}
.busCard_installment {
    font-family: Helvetica;
    font-size: $rem24;
    color: #999999;
    letter-spacing: 0;
}
@media screen and (max-width: 320px) {
    .cls-detail {
        margin: 0 $rem15 !important;
    }

    .cls-card-item.has-zongjia {
        height: $rem556;

        .zongjia-wrapper {
            align-items: flex-start;
            flex-direction: column;

            .zongjia {
                padding-left: 0;
            }
        }
    }
}

.jrm-border-2px {
    &.jrm-border-all-color:before {
        border: 2px solid #d29c52;
    }
}
</style>
